$(function () {
    var blogSingle = $(".blog-single");
	if (blogSingle.length > 0 && $(".blog-single .blog-single_right").html().trim() == "") {
		blogSingle.addClass("single-col");
	}
});